import type React from 'react';

import { tabsList } from '@mage-ui/styled-system/recipes';
import { Tabs as MantineTabList } from '@mantine/core';

export type TabsListProps = {
  classNames?: {
    list?: string;
  };
  children?: React.ReactNode;
};

export const TabsList = ({ classNames, children, ...props }: TabsListProps) => {
  return (
    <MantineTabList.List
      classNames={{
        list: classNames?.list ?? tabsList(),
      }}
      {...props}
    >
      {children}
    </MantineTabList.List>
  );
};

TabsList.displayName = 'Tabs.List';
